query GetSessionInfo {
  sessionInfo {
    id
    firstName
    surname
    email
    avatarUrl
    admin
    twoFactorEnabled
    permissions
    roles
    trainingInScope
  }
}
